import { GroupBase } from 'react-select/dist/declarations/src/types';

import { APIUserRight } from './backend';

export type MenuType = {
  returnItem?: NavigationItems;
  header?: JSX.Element;
  subHeader?: string;
  items: NavigationItems[];
};

export enum PlanFeature {
  CheckDesigner = 'hasCheckDesigner',
  CustomEmailTemplates = 'hasCustomEmailTemplates',
  ApiAccess = 'hasApiAccess',
}

export type NavigationItems = {
  id?: string;
  text?: string;
  icon?: JSX.Element;
  userRight?: APIUserRight | APIUserRight[];
  planFeature?: PlanFeature;
  url?: () => string;
  component?: JSX.Element;
  openInNewTab?: boolean;
};

export type TableSettingsT<FiltersT = Record<any, any>> = {
  hiddenColumns: string[] | null;
  columnsWidth: Record<string, number>;
  filters: FiltersT;
};

export type TypeaheadOption = {
  label: string;
  value: string;
  __isNew__?: boolean;
  options?: false;
};

export type TypeaheadDataOption<DataT> = {
  label: string;
  value: string;
  data?: DataT;
  __isNew__?: boolean;
  options?: false;
};

export type GroupedTypeaheadOption = GroupBase<TypeaheadOption>;

export interface IOptions {
  key: string | number;
  value: string;
}

export enum SettingsTab {
  General = 'general',
  Billing = 'billing',
  EmailDesigner = 'email-designer',
}

export enum BillingModal {
  Plans = 'plans',
  TopUp = 'top-up',
}
